import styled from 'styled-components'

export const DateTextContainer = styled.div`
  width: 200px;
  display: flex;
  justify-content: center;
`
